import { render, staticRenderFns } from "./MdtToggle.vue?vue&type=template&id=9a596a5c&scoped=true"
import script from "./MdtToggle.vue?vue&type=script&lang=js"
export * from "./MdtToggle.vue?vue&type=script&lang=js"
import style0 from "./MdtToggle.vue?vue&type=style&index=0&id=9a596a5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a596a5c",
  null
  
)

export default component.exports